import React from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import EmptyState from '../../../components/EmptyState';

/**
 * Empty state shown in the competitors history when the hotel has no
 * previous competitor analyses.
 */
const NoCompetitorsHistory = () => {
    const translate = useTranslate();

    return (
        <EmptyState
            iconName='AccessTimeOutlined'
            title={translate('no_competitor_history')}
            description={translate('no_competitor_history_description')}
        />
    );
};

export default NoCompetitorsHistory;
